import {useEffect, useState} from 'react'
import {
    faCss3,
    faHtml5,
    faJsSquare,
    faReact,
    faVuejs, faGithub,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
    const aboutArray = 'About Me'.split('')

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 2000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <>
            <div className="container about-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={aboutArray}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Hello, I am a person who has a strong passion for programming. I have
                        experience in creating SPA with React/Redux/TypeScript.
                    </p>
                    <p>
                        Now I am
                        improving my skills in this direction and expanding them with new
                        technologies. I'm planning to study Node.js because my next focus is to
                        become a Full-Stack Developer.
                    </p>
                    <p>
                        And also I have an interest in boosting my
                        English to C1 level.
                    </p>
                    <p>I spend my leisure time on Codewars or speaking with
                        native English speakers. Open to your suggestions.</p>
                    <div className="flat">
                        <a className="flat-link" href="https://www.canva.com/design/DAFB66uDReY/BrtpzciZaVW5eeqXTtS6EA/view?utm_content=DAFB66uDReY&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton">
                            My CV
                        </a>
                    </div>
                </div>

                <div className="stage-cube-cont">
                    <div className="cubespinner">
                        <div className="face1">
                            <FontAwesomeIcon icon={faVuejs} color="#4B8BBE"/>
                        </div>
                        <div className="face2">
                            <FontAwesomeIcon icon={faHtml5} color="#F06529"/>
                        </div>
                        <div className="face3">
                            <FontAwesomeIcon icon={faCss3} color="#28A4D9"/>
                        </div>
                        <div className="face4">
                            <FontAwesomeIcon icon={faReact} color="#5ED4F4"/>
                        </div>
                        <div className="face5">
                            <FontAwesomeIcon icon={faJsSquare} color="#EFD81D"/>
                        </div>
                        <div className="face6">
                            <FontAwesomeIcon icon={faGithub} color="#EC4D28"/>
                        </div>
                    </div>

                </div>
            </div>
            <Loader type="pacman"/>
        </>
    )
}

export default About
